/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Sched_Title5Inputs */

const en_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled pipelines`)
};

const ar_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطوط أنابيب مجدولة`)
};

const bn_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শিডিউলড পাইপলাইন`)
};

const de_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplante Pipelines`)
};

const es_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ductos programados`)
};

const fr_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines planifiés`)
};

const pt_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines programados`)
};

const zh_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预定管道`)
};

const tr_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlanmış işlem hatları`)
};

const ru_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запланированные конвейеры`)
};

const pl_svc_web_scraping_sched_title5 = /** @type {(inputs: Svc_Web_Scraping_Sched_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planowane rurociągi`)
};

/**
* | output |
* | --- |
* | "Scheduled pipelines" |
*
* @param {Svc_Web_Scraping_Sched_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_sched_title5 = /** @type {((inputs?: Svc_Web_Scraping_Sched_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Sched_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_sched_title5(inputs)
	if (locale === "bn") return bn_svc_web_scraping_sched_title5(inputs)
	if (locale === "de") return de_svc_web_scraping_sched_title5(inputs)
	if (locale === "es") return es_svc_web_scraping_sched_title5(inputs)
	if (locale === "fr") return fr_svc_web_scraping_sched_title5(inputs)
	if (locale === "pt") return pt_svc_web_scraping_sched_title5(inputs)
	if (locale === "zh") return zh_svc_web_scraping_sched_title5(inputs)
	if (locale === "tr") return tr_svc_web_scraping_sched_title5(inputs)
	if (locale === "ru") return ru_svc_web_scraping_sched_title5(inputs)
	if (locale === "pl") return pl_svc_web_scraping_sched_title5(inputs)
	return en_svc_web_scraping_sched_title5(inputs)
});
export { svc_web_scraping_sched_title5 as "svc_web-scraping_SCHED_title" }